import { white } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

export const menuStyle = isActive => `
    color: ${white};
    margin-bottom: 32px;
    font-weight: ${isActive ? 800 : 300};
`;

export const selectedStyle = `
    width: 76px;
    height: 4px;
    border-radius: 2px;
    background-color: ${white};
    margin: 3px auto 0;
`;
